export const FILTERS_SX = {
  display: 'flex',
  gap: 2,
  mb: 2,
  flexWrap: 'wrap',
};

export const SUMMARY_SX = {
  display: 'flex',
  gap: 4,
  mt: 2,
  flexWrap: 'wrap',
};
